import { POST } from '../request'

export const sendDailyEmail = ({ fecha }) =>
  POST('/api/core/marketing/mailjet/send-daily', { fecha })

export const sendLeadsDailyEmail = ({ fecha }) =>
  POST('/api/core/marketing/mailjet/send-leads-daily', { fecha })
